import { inject, Injectable } from '@angular/core';
import { catchError, first, Observable, throwError } from 'rxjs';
import { Workflow } from '../models/workflow.model';
import { WorkflowItem } from '../models/workflow-item.model';
import { DevPortalHttpClient } from 'src/app/shared/services/dev-portal-http-client.service';

@Injectable()
export class WorkflowService {
  private _devPortalHttpClient = inject(DevPortalHttpClient);

  getWorkflowsByPersonaId(personaId: number): Observable<Workflow[]> {
    return this._devPortalHttpClient.Get<Workflow[]>(`/workflows?personaId=${personaId}`)
        .pipe(
            first(),
            catchError(error => {
                console.error("Error fetching workflows:", error);
                return throwError(() => error);
            })
        );
  }

  getWorkflowItems(workflowId: number): Observable<WorkflowItem[]> {
    return this._devPortalHttpClient.Get<WorkflowItem[]>(`/workflows/${workflowId}/items`)
      .pipe(
          first(),
          catchError(error => {
              console.error("Error fetching workflow items:", error);
              return throwError(() => error);
          })
      );
  }
}
